import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5935b717")

_pushScopeId("data-v-5935b717")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "logo",
    src: "/assets/img/logo.png"
  })
], -1)
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = { class: "logo-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, {
        class: "bgimage",
        fullscreen: true
      }, {
        default: _withId(() => [
          _createVNode(_component_ion_grid, { class: "main-grid" }, {
            default: _withId(() => [
              _createVNode(_component_ion_row, { class: "main-row" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, { size: "2" }),
                  _createVNode(_component_ion_col, null, {
                    default: _withId(() => [
                      _createVNode("form", {
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args)), ["prevent"])),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args)), ["enter"])),
                        action: "#"
                      }, [
                        _hoisted_1,
                        _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('Manage My Wedding')), 1),
                        _createVNode("div", _hoisted_3, [
                          _createVNode(_component_ion_input, {
                            type: "email",
                            name: "email",
                            modelValue: _ctx.emailValue,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.emailValue = $event)),
                            placeholder: _ctx.$t('Email'),
                            class: "login-input"
                          }, null, 8, ["modelValue", "placeholder"]),
                          (_ctx.showErrors && _ctx.emailError)
                            ? (_openBlock(), _createBlock(_component_ion_text, {
                                key: 0,
                                color: "primary"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.emailError), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_4, [
                          _createVNode(_component_ion_input, {
                            type: "password",
                            name: "password",
                            modelValue: _ctx.passwordValue,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordValue = $event)),
                            placeholder: _ctx.$t('Password'),
                            class: "login-input"
                          }, null, 8, ["modelValue", "placeholder"]),
                          (_ctx.showErrors && _ctx.passwordError)
                            ? (_openBlock(), _createBlock(_component_ion_text, {
                                key: 0,
                                color: "primary"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.passwordError), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_5, [
                          _createVNode(_component_ion_button, {
                            color: "primary",
                            shape: "round",
                            type: "submit"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('Login')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ], 32),
                      _createVNode(_component_ion_grid, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, { class: "ion-text-center ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    size: "small",
                                    "router-link": "/register"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Create Account')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, { class: "ion-text-center ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    size: "small",
                                    "router-link": "/forgot_password"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Forgot Password')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "2" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})